module.exports = __webpack_public_path__ + "images/category_lp/car/assessment_achievements/4@2x_f369d4d7f8fc8ac9d79f64a55501f58d.png";